<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'departments.department' | translate }}</span>
  <button mat-icon-button matDialogClose>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<div fxLayout="row" fxLayoutAlign="center">
  @if (isActionPending | async) {
    <mat-spinner></mat-spinner>
  }
</div>

@if (!(isActionPending | async) && department$ | async; as department) {
  <div>
    <mat-dialog-content>
      <form [formGroup]="departmentForm">
        <mat-form-field>
          <mat-label>{{ 'departments.name' | translate }}</mat-label>
          <input matInput type="text" formControlName="name" maxlength="255">
        </mat-form-field>
        <!-- subscriptSizing: die globalen Formularstile reservieren keinen Platz fuer
             Hints, ohne das hier ueberlappt der Hinweis das naechste Feld. -->
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'departments.sortOrder' | translate }}</mat-label>
          <input matInput type="number" min="1" step="10" formControlName="sortOrder">
          <mat-hint>{{ 'departments.sortOrderHint' | translate }}</mat-hint>
        </mat-form-field>

        <div class="color-row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.75rem">
          <input
            type="color"
            class="color-picker"
            formControlName="color"
            [attr.aria-label]="'departments.color' | translate"
          >
          <mat-form-field class="color-value">
            <mat-label>{{ 'departments.color' | translate }}</mat-label>
            <input matInput type="text" formControlName="color" maxlength="7">
          </mat-form-field>
        </div>

        <div class="holds-row">
          <label class="holds-label">{{ 'departments.holds' | translate }}</label>
          <mat-checkbox formControlName="canHoldDrivers">{{ 'departments.people' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="canHoldVehicles">{{ 'departments.vehicles' | translate }}</mat-checkbox>
          @if (departmentForm.hasError('noKind')) {
            <div class="holds-error">{{ 'departments.holdsRequired' | translate }}</div>
          }
        </div>

        <div class="opacity-row">
          <label class="opacity-label" id="department-opacity-label">
            {{ 'departments.opacity' | translate }}: {{ departmentForm.value.opacity }} %
          </label>
          <mat-slider min="0" max="100" step="1" discrete>
            <input matSliderThumb formControlName="opacity" aria-labelledby="department-opacity-label">
          </mat-slider>
        </div>

        <!-- Zeigt genau die Darstellung der Kalenderliste: getoenter Block mit
             Vollfarb-Kante links, Schrift bleibt unabhaengig von der Farbe lesbar. -->
        <div class="preview">
          <span class="preview-label">{{ 'departments.preview' | translate }}</span>
          <div
            class="preview-block"
            [style.border-left-color]="departmentForm.value.color"
            [style.background]="previewTint"
          >
            <div class="preview-department">{{ departmentForm.value.name || ('departments.department' | translate) }}</div>
            <div class="preview-person">Max Mustermann</div>
            <div class="preview-dates">10. Aug – 21. Aug (Urlaub)</div>
          </div>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        mat-raised-button
        *ngxPermissionsOnly="['ROLE_SUPER_ADMIN']"
        color="accent"
        [disabled]="departmentForm.invalid"
        disabledInteractive
        [matTooltip]="persistHint"
        (click)="persistDepartment(department)"
      >
        <mat-icon>check</mat-icon>
        {{ 'departments.actions.persist' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
